import React, {useEffect} from 'react';
import {Menu} from "react-contexify";

const ImMenu = (props) => {
    useEffect(() => {
        // console.log('9898', React)
    })
    return (
        <>
            {React.Children.map(props.children, child => React.cloneElement(child))}
        </>
    )
}

export default ImMenu;